import { NavLink } from "react-router-dom";
import { Sun, Wallet, Map, BookHeart } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCouple } from "@/hooks/useCouple";

const TABS = [
  { to: "/", labelKey: "agora", icon: Sun, id: "agora" },
  { to: "/dinheiro", labelKey: "dinheiro", icon: Wallet, id: "nosso-dinheiro" },
  { to: "/planos", labelKey: "planos", icon: Map, id: "nossos-planos" },
  { to: "/vida", labelKey: "vida", icon: BookHeart, id: "nossa-vida" },
];

export const BottomNav = () => {
  const { labels } = useCouple();
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 px-3 pb-[max(env(safe-area-inset-bottom),10px)]"
      aria-label="Navegação principal"
    >
      <div className="paper grid grid-cols-5 items-center h-[68px] shadow-[0_12px_30px_-16px_rgba(44,34,30,0.45)] backdrop-blur-md bg-[var(--cream-card)]/95">
        {TABS.slice(0, 2).map((t) => <Tab key={t.id} {...t} label={labels[t.labelKey]} />)}
        <div />
        {TABS.slice(2).map((t) => <Tab key={t.id} {...t} label={labels[t.labelKey]} />)}
      </div>
    </nav>
  );
};

const Tab = ({ to, label, icon: Icon, id }) => (
  <NavLink
    to={to}
    end={to === "/"}
    data-testid={`nav-${id}-tab`}
    className={({ isActive }) =>
      cn(
        "flex flex-col items-center justify-center gap-1 h-full min-w-[44px] transition-colors",
        isActive ? "text-[var(--coffee)]" : "text-[var(--coffee-muted)]"
      )
    }
  >
    {({ isActive }) => (
      <>
        <Icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
        <span className={cn("condensed text-[13px] tracking-[0.08em] truncate max-w-[64px]", isActive && "underline decoration-[var(--coral)] decoration-2 underline-offset-4")}>{label}</span>
      </>
    )}
  </NavLink>
);
